import angular from 'angular';
import 'angular-translate';
import 'angular-translate-loader-partial';
import 'angular-translate-storage-cookie';
import TranslateService from './TranslateService';
import { TranslateModuleConfig } from 'modules/translate/TranslateModuleConfig';
import { AsyncTranslationLoader } from './AsyncTranslationLoader';
//
export const translateModule = angular
    .module('translate', ['pascalprecht.translate'])
    // config already in array annotated form
    .config(TranslateModuleConfig)
    // AsyncTranslationLoader has no DI params; safe as-is
    .service('AsyncTranslationLoader', AsyncTranslationLoader)
    // TranslateService now has static $inject; safe
    .service('TranslateService', TranslateService)
    .name;
